import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RitenutaAccontoPAModalComponent } from './ritenuta-acconto-pa-modal';

export const RitenutaAccontoPAModalModule: string = ng
    .module('ritenuta-acconto-pa-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('ritenutaAccontoPAModalComponent', RitenutaAccontoPAModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/ritenuta-acconto-pa-modal/ritenuta-acconto-pa-modal.module.ts